import { post } from '../http';

const getEnrolments = (schoolIds) => post('enrolmentRetrieve', { schoolIds });

const save = (id, data, eventId) => {
  let url = 'registrantsSave';
  if (id) {
    url += '?id=' + id;
  }
  if (eventId) {
    url += '?eventId=' + eventId;
  }
  return post(url, data);
};

const getExistingRegistrations = (event_id, event_date) =>
  post('registrantsRetrieve', { event_id, event_date });

const getParticipants = (start_date, end_date) =>
  post('participantsRetrieve', { start_date, end_date });

const deleteRegistrant = (pk, sk) => post('registrantDelete', { pk, sk });

const markAttendance = (student_ids, status, event) =>
  post('registrantsAttendance', { student_ids, status, eventId: event.id, eventDate: event.eventDate, attendanceMarkingComplete: event.attendanceMarkingComplete });

const registrantsIndustryExpSave = (registrantId, industryExp = false, workExp = false, iIActivity = false) =>
  post('registrantsIndustryExpSave', { registrantId, industryExp, workExp, iIActivity });

const withdraw = (student_ids) => post('registrantWithdraw', { student_ids });

export default {
  getEnrolments,
  save,
  getExistingRegistrations,
  deleteRegistrant,
  markAttendance,
  registrantsIndustryExpSave,
  withdraw,
  getParticipants,
};
